/** @jsxImportSource @emotion/react */
import { css, useTheme } from "@emotion/react";
import React, { useCallback, useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
  Input,
  Button,
  Icon,
} from "@coreai/component-library";
import { useLanguage } from "LanguageContext";
import AdvertiserSearch from "./AdvertiserSearch";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";

interface EditProjectDialogProps {
  project: any;
  open: boolean;
  onClose: () => void;
  onEdit: (projectId: string, updatedProject: any) => void;
  openBy?: string;
}

export default function EditProjectDialog(
  props: Readonly<EditProjectDialogProps>
) {
  const { t } = useLanguage();
  const theme = useTheme();
  const [advertiser, setAdvertiser] = useState<string>(
    props.project.advertiser
  );
  const [projectName, setProjectName] = useState<string>(props.project.name);
  const [isNameChanged, setIsNameChanged] = useState(false);
  const [changeName, setChangeName] = useState({ showMsg: false, oldName:'' , newName:'', allUpdate: false });
  const projectInputRef = React.useRef<HTMLInputElement>(null); // Explicitly type the ref

  const alertDialogBodyStyles = {
    border: "none",
  } as React.CSSProperties;

  const compulsoryStyles = {
    fontFamily: theme.typography.subbody_medium.fontFamily,
    fontSize: theme.typography.subbody_medium.fontSize,
    fontWeight: theme.typography.subbody_medium.fontWeight,
    color: theme.typography.subbody_medium.colors,
  } as React.CSSProperties;

  const bodyStyles = {
    fontFamily: theme.typography.bodyMedium.fontFamily,
    fontSize: theme.typography.bodyMedium.fontSize,
    fontWeight: theme.typography.bodyMedium.fontWeight,
    lineHeight: theme.typography.bodyMedium.lineHeight,
    color: theme.colors.textDark,
    marginBottom: theme.spacing.sm,
    paddingTop: 0,
    overflowY: "visible",
    gap: theme.spacing.xl,
  } as React.CSSProperties;
  const msgStyles = {
    borderRadius: '12px',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#ccc',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '16px 12px',
    backgroundColor:'#EAEEF0',
  } as React.CSSProperties;

  const editAdvertiserStyles = css`
    margin: 0px;
    p {
      display: inline;
      margin-top: 0px;
    }
  `

  useEffect(() => {
    if(projectName !== props.project.name || advertiser !== props?.project?.advertiser){
        setIsNameChanged(true);
    }else{
      setIsNameChanged(false);
    }
    
  }, [projectName, advertiser]);

  const onSave = useCallback(() => {
    if (!props.project || !props.project.id) {
      return;
    }
    const updatedProject = {
      advertiser: advertiser,
      name: projectName,
      is_to_update_all_advertiser: changeName.allUpdate,
    };

    props.onEdit(props.project.id, updatedProject);
  }, [advertiser, projectName, props.project]);
  
  const setFocuseAdver = () => {
    if (projectInputRef.current) {
      projectInputRef.current.focus();    
    }
  };

  const updateocuseAdver = (data: any) => {
    setChangeName(data);
  };
  return (
    <AlertDialog
      open={props.open}
      onOpenChange={(isOpen) => !isOpen && props.onClose()}
    >
      
      <AlertDialogContent size="sm">
        <AlertDialogHeader style={alertDialogBodyStyles}>
          <AlertDialogTitle>{t("project_editProject_title")}</AlertDialogTitle>
        </AlertDialogHeader>
 
        <AlertDialogBody style={bodyStyles}>
        {changeName?.showMsg &&  <div
         style={msgStyles}
       >
      {changeName?.oldName && changeName?.newName && 
      <p css={editAdvertiserStyles}>
        <Icon style={{top: '4px', right: '3px'}} name="announcement" size="xs" />
        <Markdown  rehypePlugins={[rehypeRaw]}>
          {t("advertiser_rename_confirmation", {
            old_adv: changeName?.oldName,
            new_adv: changeName?.newName,
          })}
        </Markdown>
        {/* <b>{changeName?.oldName}</b> {t("will_be_updated_to")} {changeName?.newName} {t("on_all_projects_using_this_title")}. <b>{changeName?.oldName}</b> {t("will_be_deleted")}. */}
      </p>
    }
    </div>
    }
          <div>
            <AdvertiserSearch
                setAdvertiser={(advertiser) => setAdvertiser(advertiser)}
                focuseNext={setFocuseAdver}
                advertiser={advertiser}
                setChangeName={updateocuseAdver}
              />
          </div>
          <div>
            <Input
              label={t("project_editProject_label_project")}
              placeholder={t("project_newProject_placeHolder_project")}
              style={{ width: "100%" }}
              value={projectName}
              onChange={(ev) => setProjectName(ev.target.value)}
              autoComplete="off"
              ref={projectInputRef}
            />
          </div>
          <div style={compulsoryStyles}>{t("core_compulsory_field")}</div>
        </AlertDialogBody>

        <AlertDialogFooter style={alertDialogBodyStyles}>
          <AlertDialogCancel asChild>
            <Button variant="tertiary">{t("core_cancel")}</Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              variant={"brand"}
              style={{ backgroundColor: theme.colors.primary }}
              onClick={onSave}
              disabled={projectName === "" || !isNameChanged}
              className="brandPrimaryBtn"
            >              
             {!props?.openBy ?t("core_save") : t("continue") }
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
